/**
 * 消息通知
 */
<template>
  <div style="margin-top: 20px;">
     <!-- 左边导航 -->
    <div style="font-weight: 700;float: left;display: flex;line-height: 40px;height: 40px;">
      <div class="mouse" :class="{'selected':caseAdviceAuthCh}" @click="clickLabel('case')">案件消息</div>
      <div class="mouse" :class="{'selected':cusAdviceAuthCh}" @click="clickLabel('customer')">客户消息</div>
      <div class="mouse" :class="{'selected':clueAdviceAuthCh}" @click="clickLabel('clue')">线索消息</div>
      <div class="mouse" :class="{'selected':sysAdviceAuthCh}" @click="clickLabel('system')">系统消息</div>
    </div>
    <!-- 右侧按钮 -->
    <div style="float: right;display: flex;">
      <el-button size="small" icon="el-icon-refresh" class="clue-btn" @click="refreshData">刷新</el-button>
      <!-- <el-button size="small" icon="el-icon-bottom" class="clue-btn" @click="checkDownLoad">表格下载</el-button>
      <el-button size="small" icon="el-icon-top" class="clue-btn" @click="handleImport">表格上传</el-button> -->
    </div>
    <el-table size="small" :data="adviceData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark" ref="multipleTable" @selection-change="handleSelectionChange">
        <el-table-column align="center" type="selection" width="40">
        </el-table-column>
        <el-table-column align="center" type="index" label="序号" width="60">
        </el-table-column>
        <el-table-column prop="send_name" align="center" label="发送者" width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="type" align="center" label="类型" width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="content" align="center" label="内容" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="is_view" align="center" label="状态" :formatter="matterView" width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="add_time" align="center" label="发送时间" width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <!-- <el-button size="mini" type="primary" @click="previewDoc(scope.index, scope.row)">预览</el-button> -->
            <!-- <el-button size="mini" type="primary" @click="loadDoc(scope.index, scope.row)">下载</el-button> -->
            <!-- <el-button v-if="editDocAuth" size="mini" type="primary" @click="handleEdit(scope.index, scope.row)">编辑</el-button> -->
            <el-button v-if="scope.row.is_link == 2 && scope.row.module == 'case'" size="mini" type="primary" @click="getCaseApplyInfo(scope.index, scope.row, 2)">审核</el-button>
            <el-button v-if="scope.row.is_link == 1 && scope.row.module == 'case'" size="mini" type="primary" @click="getCaseApplyInfo(scope.index, scope.row ,1)">查看</el-button>
            <el-button v-if="scope.row.is_view == 1 && scope.row.module == 'customer'" size="mini" type="primary" @click="getAdviceInfo(scope.index, scope.row)">查看</el-button>
            <el-button v-if="scope.row.is_view == 1 && scope.row.module == 'clue'" size="mini" type="primary" @click="getAdviceInfo(scope.index, scope.row)">查看</el-button>
            <el-button v-if="scope.row.is_view == 1 && scope.row.module == 'system'" size="mini" type="primary" @click="getAdviceInfo(scope.index, scope.row)">查看</el-button>
          </template>
        </el-table-column>
    </el-table>

    <!-- 案件修改申请审核页面 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :title="title" :visible.sync="verifyFormVisible" width="850px" height="400px">
      <el-descriptions title="原始数据" :column="4" :size="size" border :label-style="labelCS">
         <el-descriptions-item><template slot="label">申请事项</template>{{ verifyForm.old_apply_item }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">申请日</template>{{ verifyForm.old_apply_date }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">申请号</template>{{ verifyForm.old_apply_number }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">客户</template>{{ verifyForm.old_customer_name }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">委托事宜</template>{{ verifyForm.old_entrust }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">类型</template>{{ verifyForm.old_case_type }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">端口</template>{{ verifyForm.old_report }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">总费</template>{{ verifyForm.old_total_cost }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">规费</template>{{ verifyForm.old_fees }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">代理费</template>{{ verifyForm.old_agency_fee }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">成本</template>{{ verifyForm.old_cost }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">返点</template>{{ verifyForm.old_point }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">备注</template>{{ verifyForm.old_case_desc }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions title="新数据" :column="4" :size="size" border style="margin-top: 10px;" :label-style="labelCS">
         <el-descriptions-item><template slot="label">申请事项</template>{{ verifyForm.new_apply_item }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">申请日</template>{{ verifyForm.new_apply_date }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">申请号</template>{{ verifyForm.new_apply_number }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">客户</template>{{ verifyForm.new_customer_name }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">委托事宜</template>{{ verifyForm.new_entrust }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">类型</template>{{ verifyForm.new_case_type }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">端口</template>{{ verifyForm.new_report }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">总费</template>{{ verifyForm.new_total_cost }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">规费</template>{{ verifyForm.new_fees }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">代理费</template>{{ verifyForm.new_agency_fee }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">成本</template>{{ verifyForm.new_cost }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">返点</template>{{ verifyForm.new_point }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">备注</template>{{ verifyForm.new_case_desc }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="4" :size="size" border style="margin-top: 10px;" :label-style="labelCS">
         <el-descriptions-item><template slot="label">状态</template>{{ verifyForm.status }}</el-descriptions-item>
         <el-descriptions-item><template slot="label">申请理由</template>{{ verifyForm.reason }}</el-descriptions-item>
      </el-descriptions>
      
      <div style="margin-top: 10px;">
        <el-button v-if="verifyForm.status == '待审核'" type="primary" size="small" @click="handleVerifyCaseApply('同意')">同意</el-button>
        <el-button v-if="verifyForm.status == '待审核'" type="danger" size="small" @click="handleVerifyCaseApply('拒绝')">拒绝</el-button>
        <el-button size="small" @click="closeVerify">关闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
  import { 
   getAdviceList,
   getCaseApply,
   setAdviceRead,
   verifyCaseApply,
   getUnreadAdviceNum 
  } from '../../api/crmMG'
  import Pagination from '../../components/Pagination'
  import '../../assets/js/directive'
  import { checkLogin } from '../../utils/util'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        verifyFormVisible: false, //控制案件修改申请审核页面显示与隐藏

        caseAdviceAuthCh: false,
        cusAdviceAuthCh: false,
        clueAdviceAuthCh: false,
        sysAdviceAuthCh: false,

        formInline: {
          page: 1,
          ps: 15,
          module: 'case'
        },
        verifyForm: {},
        labelCS: {
          'width': '80px',
          'word-break': 'break-all'
        },
        contentCS: {
          'width': '120px',
          'word-break': 'break-all'
        },
        multipleSelection: [],
        adviceData: [],

        title: '',
        size: '10px',

        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 15,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getAdviceData()
      this.caseAdviceAuthCh = true
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 顶部label切换
      clickLabel(name) {
        if(name == 'case') {
          this.caseAdviceAuthCh = true
          this.cusAdviceAuthCh = false
          this.clueAdviceAuthCh = false
          this.sysAdviceAuthCh = false
          this.formInline.module = 'case'
          this.formInline.page = 1
        }else if(name == 'customer') {
          this.caseAdviceAuthCh = false
          this.cusAdviceAuthCh = true
          this.clueAdviceAuthCh = false
          this.sysAdviceAuthCh = false
          this.formInline.module = 'customer'
          this.formInline.page = 1
        }else if(name == 'clue') {
          this.caseAdviceAuthCh = false
          this.cusAdviceAuthCh = false
          this.clueAdviceAuthCh = true
          this.sysAdviceAuthCh = false
          this.formInline.module = 'clue'
          this.formInline.page = 1
        }else {
          this.caseAdviceAuthCh = false
          this.cusAdviceAuthCh = false
          this.clueAdviceAuthCh = false
          this.sysAdviceAuthCh = true
          this.formInline.module = 'system'
          this.formInline.page = 1
        }
         this.getAdviceData()
      },

      handleSelectionChange(val){
        this.multipleSelection = val;
      },
      // 查询消息列表
      getAdviceData() {
        this.loading = true
        getAdviceList(this.formInline)
        .then(res=>{
          res = checkLogin(res)
          if(res.code == 200){
            this.adviceData = res.data.dataList
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.loading = false
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            }) 
          }
        })
      },
      // 查询案件申请详情
      getCaseApplyInfo(index, row, type) {
        console.log(row)
        // let relate_id = row.relate_id
        let advice_id = row.id
        let param = {
          relate_id: row.relate_id,
          advice_id: advice_id,
          type: type
        }
        getCaseApply(param)
        .then(res=>{
          if(res.code == 200){
            console.log(res)
             this.title = '案件修改审核'
             this.verifyFormVisible = true
             this.verifyForm = res.data
             this.verifyForm.advice_id = advice_id
             if(type == 1){
                this.getAdminMsgNum()
             }
          }else{
             this.$message({
              type: 'error',
              message: res.msg
             })
          }
        })
       
      },
      // 审核案件修改
      handleVerifyCaseApply(result) {
        let status = result
        let verifyForm = this.verifyForm
        let param = {
          status: status,
          relate_id: verifyForm.id,
          advice_id: verifyForm.advice_id
        }
        verifyCaseApply(param)
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getAdviceData()
            this.getAdminMsgNum()
            this.verifyFormVisible = false
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
        
      },
      // 关闭案件审核弹窗
      closeVerify(){
        this.verifyFormVisible = false
        this.refreshData()
      },
      // 查询消息详情
      getAdviceInfo(index, row) {
        setAdviceRead({id: row.id})
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getAdviceData()
            this.getAdminMsgNum()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      },
       // 查询账户未读消息数量
      getAdminMsgNum() {
        let param = {}
        getUnreadAdviceNum(param)
        .then(res=>{
          if(res.code == 200){
            this.resetSetItem('noticeCount', res.data.num);
          }
        })
      },

      // 刷新数据
      refreshData() {
        this.getAdviceData()
      },
      // 消息状态
      matterView: function(obj) {
      if(obj.is_view == 1){
          return '未读'
      }else if(obj.is_view == 2){
          return '已读'
      }else{
          return '其他'
      }
    },
    }
  }
</script>
<style scoped>
  .mouse {
    cursor: pointer;
    color: #D9D9D9;
    margin-right: 18px;
  }
  .selected {
    color: #333333;
  }
  .clue-btn {
    background-color: #333333;
    color: #FFFFFF;
  }
  .el-descriptions__header {
    margin-bottom: 10px !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/crm/advice.vue